import { useState } from 'react'

interface Props {
  onResume: () => void
  onRestart: () => void
  onMenu: () => void
  onSettings: () => void
}

export function PauseOverlay({ onResume, onRestart, onMenu, onSettings }: Props) {
  const [confirmQuit, setConfirmQuit] = useState(false)

  return (
    <div className="dim overlay" style={{ zIndex: 15 }}>
      <div className="panel">
        <h1 className="h1">Пауза</h1>
        <p className="muted">Таймер остановлен.</p>
        {!confirmQuit ? (
          <div className="btn-row">
            <button type="button" className="btn btn-primary" onClick={onResume}>
              Resume
            </button>
            <button type="button" className="btn btn-ghost" onClick={onRestart}>
              Restart
            </button>
            <button type="button" className="btn btn-ghost" onClick={onSettings}>
              Settings
            </button>
            <button type="button" className="btn btn-ghost" onClick={() => setConfirmQuit(true)}>
              Menu
            </button>
          </div>
        ) : (
          <>
            <p className="muted" style={{ marginTop: 12 }}>
              Покинуть партию? Прогресс будет потерян.
            </p>
            <div className="btn-row">
              <button type="button" className="btn btn-primary" onClick={onMenu}>
                Да, в меню
              </button>
              <button type="button" className="btn btn-ghost" onClick={() => setConfirmQuit(false)}>
                Отмена
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
